<div class="alain-default__header-logo" style="width: auto;">
    <a class="mobile-menu-toggle" (click)="toggleMenu.emit(!isToggleMenu)">
        <i nz-icon nzType="menu" nzTheme="outline"></i>
    </a>
    <!-- <a target="_blank" class="alain-default__header-logo-link">
         <img class="alain-default__header-logo-expanded" src="{{logoImage}}" alt="{{settings.app.name}}" style="max-height:40px;" />
    </a> -->
</div>
<div class="alain-default__nav-wrap">
    <ul class="alain-default__nav">
        <!-- <li>
            <a href="/trang-chu">
                <img src="{{logoImage}}" alt="{{settings.app.name}}" style="max-height:40px;" />
            </a>
        </li> -->
        <!-- <li style="font-weight: bold; text-transform: uppercase">
            <h1 class="title-he-thong">Hệ thống thông tin tổng thể quản lý và hỗ trợ truy xuất nguồn gốc mỹ phẩm</h1>
        </li> -->
    </ul>
    <ul class="alain-default__nav">
        <li *ngIf="isImpersonatedLogin">
            <button (click)="backToMyAccount()" nz-button nzType="link" title="Quay lại tài khoản chính">
                <i nz-icon nzType="api" nzTheme="outline"></i>
            </button>
        </li>
        <!-- <li class="px-md-3">
            <a href="/trang-chu" class="direct-home">
                <i nz-icon nzType="rollback" nzTheme="outline"></i><span class="font-weight-bold"> Quay lại trang
                    chủ</span>
            </a>
        </li> -->
        <li class="hidden-mobile">
            <header-user style="float: left;"></header-user>
        </li>
    </ul>
</div>